import React, { useState, useEffect } from 'react'
import {
  SaveButton,
  EditButton,
  Toolbar,
  useRecordContext,
  useResourceContext,
  useResourceDefinitions,
  useStore,
  useTranslate
} from 'react-admin'
import { Edit, Save } from '@mui/icons-material'
import { getResourceName } from 'src/helper/getResourceName'
import { DeleteButtonWithConfirmation } from '../buttons/DeleteButtonWithConfirmation'

export const CardCrudBottomButtons = ({
  btnEdit,
  btnSave,
  btnDelete,
  fieldsName = [],
  genderElement,
  beforeSubmit,
  loading = false
}) => {
  const record = useRecordContext()
  const translate = useTranslate()
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resource = useResourceContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resource]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resource])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  const handleClick = (e) => {
    if (beforeSubmit && !beforeSubmit()) {
      e.preventDefault()
    }
  }

  return (
    <Toolbar>
      <div className='cardCrudBottomButtons'>
        <div className='leftSide'>
          {btnEdit && permissions?.hasEdit && (
            <EditButton
              className='button'
              size='medium'
              label={translate('ra.action.edit')}
              icon={<Edit />}
              variant='contained'
              disabled={loading}
            />
          )}
          {btnSave && permissions?.hasCreate && (
            <SaveButton
              id="saveButtonCustom"
              size='medium'
              icon={<Save />}
              variant='contained'
              onClick={handleClick}
              alwaysEnable={!loading}
              disabled={loading}
            />
          )}
        </div>
        <div className='rightSide'>
          {btnDelete && permissions?.options?.delete && (
            <DeleteButtonWithConfirmation
              record={record}
              resource={resource}
              name={getResourceName(record, fieldsName)}
              genderElement={genderElement}
              label={translate('ra.action.delete')}
              variant='outlined'
              color='error'
              size='medium'
            />
          )}
        </div>
      </div>
    </Toolbar>
  )
}
